import React, {useCallback, useEffect, useRef} from 'react';
import {createPortal} from 'react-dom';
// import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';
import OutsideClickHandler from 'react-outside-click-handler';
import cn from 'classnames';
import Icon from 'components/acommon/Icon';
import {WarningCloseModal} from './WarningCloseModal/WarningCloseModal';
import styles from './Modal.module.sass';

export type ModalProps = {
  outerClassName?: string;
  visible: boolean;
  onClose: () => void;
  children: React.ReactNode;
  warningCloseModal?: boolean;
  densed?: boolean;
};

const Modal = ({
  outerClassName,
  visible,
  onClose,
  children,
  densed,
  warningCloseModal,
}: ModalProps) => {
  const [isOpenWarningCloseModal, setIsOpenWarningCLoseModal] = React.useState(false);
  const escFunction = useCallback(
    e => {
      if (visible && e.keyCode === 27) {
        warningCloseModal ? setIsOpenWarningCLoseModal(true) : onClose();
      }
    },
    [onClose, visible, warningCloseModal],
  );

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);
    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, [escFunction]);

  const scrollRef = useRef<HTMLDivElement>(null);

  // hided feature
  // useEffect(() => {
  // const modalContainer = scrollRef.current;
  // if (modalContainer)
  //   visible ? disableBodyScroll(modalContainer) : enableBodyScroll(modalContainer);
  // return () => {
  //   if (modalContainer) enableBodyScroll(modalContainer);
  // };
  // }, [visible, scrollRef]);

  const handleCloseWarningModal = () => {
    setIsOpenWarningCLoseModal(false);
    onClose();
  };

  const handleContinueWarningModal = () => {
    setIsOpenWarningCLoseModal(false);
  };

  return createPortal(
    visible && (
      <>
        <WarningCloseModal
          visible={isOpenWarningCloseModal}
          onClose={handleCloseWarningModal}
          onContinue={handleContinueWarningModal}
        />
        <div className={styles.modal} ref={scrollRef}>
          <div
            className={cn(styles.outer, outerClassName, {
              [styles.densed]: densed,
            })}
          >
            <OutsideClickHandler
              onOutsideClick={isOpenWarningCloseModal ? () => {} : onClose}
            >
              {children}
              <button className={styles.close} onClick={onClose}>
                <Icon name="close" size="24" />
              </button>
            </OutsideClickHandler>
          </div>
        </div>
      </>
    ),
    document.body,
  );
};

export {Modal};
